import { Loader } from '../common/loader';

const SentInvitations = function ($scope, $element, initialDataInteractor, invitationInteractor, eventsService) {
  const $ctrl = this;

  $ctrl.$onInit = function () {
    $ctrl.loader = new Loader($element[0]);
    invitationInteractor.withSentInvitations().then(() => {
      $ctrl.invitations = invitationInteractor.sentInvitations;
      $ctrl.loader.remove();
      $scope.$digest();
    });
  };

  $ctrl.refreshList = function () {
    $scope.$digest();
  };

  $ctrl.deleteInvitation = function (invitation) {
      return invitationInteractor.deleteSentInvitation(invitation)
        .then(() => $scope.$digest(),
              () => eventsService.publishSystemMessage('Failed to delete the invitation'));
  };
};

export default {
  name: 'sentInvitations',
  obj: {
    controller: SentInvitations,
    templateUrl: 'components/sent_invitations.html'
  },
  deps: []
}